import React, {createRef} from "react"

// @ts-ignore
import SelectorWithInfo from "../../selector/selector-with-info-depricated/selector-with-info"
import {SystemStatusFilter} from "../task/@types";

type Props = {
    title               : string
    inputPlaceholder    : string
    search              : string
    statusId?           : SystemStatusFilter

    onBack?             : func,
    onSearchChange      : func
    onStatusSelect?     : func | null
    onSearchCancel      : func
    onClose             : func
}

export default class FinderHeader extends React.Component<Props> {

    private inputRef: any = createRef()

    componentDidMount() {
        setTimeout(()=>{this.inputRef.current?.focus()}, 0)
    }

    onSearchChange = (event: any) => {
        const value = event.target.value ? event.target.value : '';
        if (this.props.onSearchChange) this.props.onSearchChange(value);
    };

    render() {
        const items = [
            { id:"open",    label:"Open",   info: "Show open items only" },
            // { id:"closed",  label:"Closed", info: "Show closed items only" },
            { id:"all",     label:"All",    info: "Show all items" }
        ]

        const classes = Classes('header h-110', {
            'with-go-back': !!this.props.onBack
        })

        return (
            <div className={classes}>
                {!!this.props.onBack &&
                    <div className="btn-go-back gd-btn-arrow-left-gray-22" onClick={this.props.onBack}/>}

                <div className="title">{this.props.title}</div>
                <div className="search">
                    <input ref          = {this.inputRef}
                           type         = "input"
                           className    = ""
                           value        = {this.props.search}
                           onChange     = {this.onSearchChange}
                           placeholder  = {this.props.inputPlaceholder}/>

                    <div className="i5-search"/>

                    {!!this.props.search && <div className="i5-delete" onClick={this.props.onSearchCancel}/>}
                </div>

                {this.props.onStatusSelect &&
                    <SelectorWithInfo className     = "items-status-selector"
                                      items         = {items}
                                      type          = "underlined"
                                      selectedId    = {this.props.statusId}
                                      onChange      = {this.props.onStatusSelect}
                                      hint          = "System status"/>}

                <div className="i5-delete" onClick={this.props.onClose}/>
            </div>
        )
    }
}